import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import Banner from "../../../views/components/sections/Banner";
import ServiceListingSection from "./ServiceListingSection";
import { usePageDetail, usePageSave } from "../../../hooks/api/pages/hooks";
import { getSingleImageUrl } from "../../../lib/utils";
import { useMessageApi } from "../../../provider/AntdNotification";
import TabsContain from "../../../views/components/reuseComp/TabsContain";
import { useQueryState } from "nuqs";

const ServiceTabs: React.FC<{setBreadcrumb: React.Dispatch<React.SetStateAction<string>>}> = ({setBreadcrumb}) => {
  const message = useMessageApi()
  const [tab, setTab] = useQueryState("tab")
  const activeTab = tab || "Banner"
  const [isEditing, setIsEditing] = useState(false);
  const [form] = Form.useForm();
  const [pageData, setPageData] = useState<any>(null);

  const { data } = usePageDetail("SERVICE");
  const { mutate: updateService, isPending } = usePageSave({});

  useEffect(() => {
    if (data?.data) setPageData(data.data);
  }, [data]);

  const handleChangeTab = (section: string) => {
    setTab(section);
    setIsEditing(false);
    setBreadcrumb(section);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields(); 

      let payload: any = {
        _id: pageData?._id,
        pageType: "SERVICE",
        banner: pageData?.banner || {},
        service: pageData?.service || {},
      };

      if (values.banner) {
        payload.banner = {
          ...values.banner,
          image: getSingleImageUrl(values.banner?.image),
        };
      }

      if (values.service) {
        payload.service = {
          ...values.service,
        };
      }

      updateService(payload, {
        onSuccess: (res) => {
          message.success("Page updated successfully");
          setPageData(res.data);
          setIsEditing(false);
        },
        onError: () => {
          message.error("Failed to update page");
        },
      });
    } catch (error) {
      console.log("❌ Validation failed:", error);
    }
  };

  const sections = ["Banner", "Service Listing"];

  return (
    <div>
      <TabsContain
        sections={sections}
        handleChangeTab={handleChangeTab}
        activeTab={activeTab}
      />


      {activeTab === "Banner" && (
        <Banner
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCancel={handleCancel}
          handleSave={handleSave}
          form={form}
          bannerData={pageData?.banner}
          loading={isPending}
        />
      )}

      {activeTab === "Service Listing" && (
        <ServiceListingSection/>
      )}
    </div>
  );
};

export default ServiceTabs;
